import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer, toast, cssTransition } from "react-toastify";
import { ToastContainerProps } from "react-toastify/dist/types";

import { CloseButton } from "./CloseButton";
import { getTopOffsetLayout } from "../../helpers/dom.helper";
import { getRtl } from "../../store/language.selectors";
import { AUTO_CLOSE_TIMEOUT, Notificator } from "./store";
import { getTopOffsetElements } from "../../store/layout";
import { useOnRouteChange } from "../../router/hooks";

import "./NotificationContainer.scss";

const defaultOptions: ToastContainerProps = {
  hideProgressBar: true,
  autoClose: AUTO_CLOSE_TIMEOUT,
  position: toast.POSITION.TOP_CENTER,
  className: "notification-wrapper",
  closeButton: CloseButton,
  closeOnClick: false,
  icon: false,
  draggable: false,
};

const Fade = cssTransition({
  enter: "fade-in",
  exit: "fade-out",
});

interface NotificationContainerContentProps {
  isRtl: boolean;
}

const NotificationContainerContent = ({
  isRtl,
}: NotificationContainerContentProps) => {
  const topOffsetElements = useSelector(getTopOffsetElements);
  const topOffset = getTopOffsetLayout(topOffsetElements);

  return (
    <ToastContainer
      {...defaultOptions}
      rtl={isRtl}
      role="alert"
      transition={Fade}
      style={{ top: topOffset }}
      limit={1}
    />
  );
};

export const NotificationContainer = () => {
  const rtl = useSelector(getRtl);
  const dispatch = useDispatch();

  useOnRouteChange(() => {
    dispatch(Notificator.removeAllContextual());
  });

  return <NotificationContainerContent isRtl={rtl} />;
};
